import { createContext, useContext } from 'react';
import { MDContextType } from './types';

export const MDContext = createContext<MDContextType | undefined>(undefined);

const useMDContext = ()  => {
  const context = useContext(MDContext);
  if (!context) {
    throw new Error('useMDContext must be used within an MDContextProvider');
  }
  return context;
};

export default useMDContext;